import { Text, Button } from '@gympass/yoga';
import { FormattedMessage } from 'react-intl';

import { ConfirmationStepProps } from './types';

import { TitleContainer, DrawerTitle } from '../../styles';
import * as S from './styles';

const ConfirmationStep: React.FC<ConfirmationStepProps> = ({
  isLoading,
  titleKey,
  onConfirm,
  onBack,
}) => {
  return (
    <S.ConfirmationStep>
      <S.InfoContainer>
        <TitleContainer>
          <DrawerTitle data-testid="drawerTitle">
            <FormattedMessage id="PSYCHOLOGICALRECORD.SECTIONTITLE.ADDINFO" />
          </DrawerTitle>
        </TitleContainer>
        <S.StyledAlertTriangle />
        <Text.H3 data-testid="confirmationTitle">
          <FormattedMessage id={titleKey} />
        </Text.H3>
        <S.ConfirmationMessage>
          <FormattedMessage id="PSYCHOLOGICALRECORD.SUBTITLE.CONFIRMATION" />
        </S.ConfirmationMessage>
      </S.InfoContainer>

      <S.ButtonsContainer>
        <S.ConfirmationButton
          onClick={onConfirm}
          loading={isLoading}
          data-testid="confirmNewEntryButton"
        >
          <FormattedMessage id="PSYCHOLOGICALRECORD.BUTTON.CONTINUE" />
        </S.ConfirmationButton>
        <Button.Link onClick={onBack} data-testid="goBackButton">
          <FormattedMessage id="PSYCHOLOGICALRECORD.BUTTON.GOBACK" />
        </Button.Link>
      </S.ButtonsContainer>
    </S.ConfirmationStep>
  );
};

export default ConfirmationStep;
